const t = {
  name: "Click",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 1V5H9V1H11Z" fill="currentColor"/>
<path d="M6.41436 5L3.00015 1.58578L1.58594 3L5.00015 6.41421L6.41436 5Z" fill="currentColor"/>
<path d="M23.8649 11.6855L7.62549 7.62564L11.6854 23.8651L15.7452 15.7454L23.8649 11.6855ZM12.3144 18.1349L10.3742 10.3744L18.1348 12.3145L14.2545 14.2547L12.3144 18.1349Z" fill="currentColor"/>
<path d="M5 9V11H1V9H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Click
};
